import { FC, useState } from 'react';

import {
  AccreditationCriteria,
  BenefitsSection,
} from '../InvestmentEntities/utils/HelperComponents';
import { AccreditationFAQs } from './AccreditationFAQs';

type KnowledgeTab = 'eligibility' | 'benefits' | 'faqs';

const TABS: { id: KnowledgeTab; label: string }[] = [
  { id: 'eligibility', label: 'Who qualifies' },
  { id: 'benefits', label: 'Why get accredited' },
  { id: 'faqs', label: 'FAQs' },
];

/**
 * Reference material, kept behind tabs and below the fold so the page opens on
 * what the investor has to do rather than on three screens of explanation.
 */
const AccreditationKnowledgeSection: FC = () => {
  const [currentTab, setCurrentTab] = useState<KnowledgeTab>('eligibility');

  return (
    <section aria-labelledby="accreditation-knowledge-heading">
      <div className="mb-4">
        <h2 id="accreditation-knowledge-heading" className="mb-1 font-bold text-gray-900">
          Learn about accreditation
        </h2>
        <p className="text-sm text-gray-600">
          Eligibility criteria, what accreditation unlocks, and answers to common questions.
        </p>
      </div>

      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8" aria-label="Accreditation information">
          {TABS.map(tab => {
            const isActive = currentTab === tab.id;

            return (
              <button
                key={tab.id}
                type="button"
                aria-current={isActive ? 'page' : undefined}
                className={[
                  'whitespace-nowrap border-b-2 px-1 pb-2 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2',
                  isActive
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                ].join(' ')}
                onClick={() => setCurrentTab(tab.id)}
              >
                {tab.label}
              </button>
            );
          })}
        </nav>
      </div>

      <div className="pt-8">
        {currentTab === 'eligibility' && <AccreditationCriteria showAtComponent="ACCREDITATION" />}
        {currentTab === 'benefits' && <BenefitsSection />}
        {currentTab === 'faqs' && (
          <div className="rounded-lg bg-gray-50 p-4">
            <AccreditationFAQs defaultOpen={true} />
          </div>
        )}
      </div>
    </section>
  );
};

export default AccreditationKnowledgeSection;
